import React from 'react'
import styles from './InviteFriendsDialog.scss'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { apiv3 } from 'lib/apiv3'
import { getCurrentUser } from 'lib/utils'
import { FormSubmitHack } from 'common/FormSubmitHack'
import fetchJSON from 'lib/fetchJSON'
import { infoMessage, errorMessage } from 'lib/styleguide/base.scss'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  error: {
    id: 'inviteFriendsDialog.error',
    defaultMessage: 'Please choose a trip and include a valid email address',
    description: 'An error message'
  },
  placeholder: {
    id: 'inviteFriendsDialog.placeholder',
    defaultMessage: 'friend@domain.com',
    description: 'A placeholder for an email address entry field'
  },
  selectTrip: {
    id: 'inviteFriendsDialog.selectTrip',
    defaultMessage: 'Select trip'
  }
})

export const INVITE_FRIENDS_DIALOG = 'INVITE_FRIENDS_DIALOG'

export class InviteFriendsDialog extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      recentTrips: null,
      info: null,
      error: null,
      tripId: null,
      email: null
    }
  }

  componentDidMount () {
    this.preloadNonRenderBlockingData()
  }

  preloadNonRenderBlockingData = () => apiv3.search({
    userId: getCurrentUser().id,
    sortBy: 'created DESC',
    limit: 5,
    types: ['trips']
  }).then(res => {
    let recentTrips = res.results.map((v) => [v.get('id'), v.get('name')])
    this.setState({ recentTrips: recentTrips })
  })

  onTripSelectChange = (e) => {
    this.setState({ tripId: parseInt(e.target.value, 10) })
  }

  onEmailChange = (e) => {
    this.setState({ email: e.target.value })
  }

  submitForm = (e) => {
    e && e.preventDefault()
    const { tripId, email, recentTrips } = this.state
    const { intl } = this.props
    const missing = recentTrips.map(([k, _]) => (k)).indexOf(tripId) === -1 || email.length === 0

    if (missing) {
      this.setState({ error: intl.formatMessage(messages.error) })
    } else {
      fetchJSON('/referrals', { trip_id: tripId, email: email })
        .then((res) => {
          this.setState({ info: res.meta.message, error: null })
        })
        .catch((res) => {
          this.setState({ info: null, error: res.error })
        })
    }
  }

  render () {
    const { recentTrips, info, error } = this.state
    const { intl, onRequestClose } = this.props

    return (
      <ModalOverlay maxWidth={'600px'} onRequestClose={onRequestClose}>
        <div className={styles.inner}>
          <FormSubmitHack />
          {error && <p className={errorMessage}>{error}</p>}
          {info && <p className={infoMessage}>{info}</p>}
          <h2 className={styles.header}><T id='inviteFriendsDialog.recommend' defaultMessage='Recommend this site' /></h2>
          <div className={styles.text}>
            <T id='inviteFriendsDialog.top'
              defaultMessage='We will send one email inviting your friend(s) to try out Ride
            with GPS. This is a one time email; email addresses are not kept on
            file.' />
          </div>
          <div className={styles.text}>
            <T id='inviteFriendsDialog.middle'
              defaultMessage='If a friend you invited joins Ride with GPS and uses their
            account to plan or record an activity, you will receive a one month
            free premium subscription!' />
          </div>
          <form id='invite' onSubmit={this.submitForm}>
            <label><T id='inviteFriendsDialog.shareTrip' defaultMessage="Share a recent trip with your friend(s) to show them what we're all about!" /></label>
            <select id='tripId' name='trip_id' onChange={this.onTripSelectChange}>
              <option value='' disabled selected>{intl.formatMessage(messages.selectTrip)}</option>
              {recentTrips && recentTrips.map(([k, v]) => (<option key={k} value={k}>{v}</option>))}
            </select>
            <label><T id='inviteFriendsDialog.enterEmail' defaultMessage='Enter an email address below to send an invitation.' /></label>
            <input id='email' type='text' placeholder={intl.formatMessage(messages.placeholder)} onChange={this.onEmailChange} />
          </form>
          <CTA button type='submit' onClick={this.submitForm}><T id='inviteFriendsDialog.sendInvitation' defaultMessage='Send Invitation' /></CTA>
        </div>
      </ModalOverlay>
    )
  }
}
